import { useSortedLocalizedLifeAreas } from 'features/life-areas';
import { useSmartLists } from 'features/smart-lists';
import {
  useLifeAreasSectionOpen,
  useSmartListsSectionOpen,
} from 'features/user';
import { MainNavigationItemId } from 'shared/routes/navigation/types/navigation-item';

export type SubItemDisclosure = {
  hasChildren: boolean;
  open: boolean;
  onToggle: () => void;
};

// Smart lists persist their fold state on the user doc, life areas per-browser — deliberately different.
export const useSubItemDisclosure = (
  id: MainNavigationItemId,
): SubItemDisclosure | undefined => {
  const smartLists = useSmartLists();
  const lifeAreas = useSortedLocalizedLifeAreas({ activeOnly: true });
  const [smartListOpen, setSmartListOpen] = useSmartListsSectionOpen();
  const [lifeAreasOpen, setLifeAreasOpen] = useLifeAreasSectionOpen();

  if (id === MainNavigationItemId.AllTasks) {
    return {
      hasChildren: !!smartLists.length,
      open: smartListOpen,
      onToggle: () => setSmartListOpen((prev) => !prev),
    };
  }

  if (id === MainNavigationItemId.LifeAreas) {
    return {
      hasChildren: !!lifeAreas.length,
      open: lifeAreasOpen,
      onToggle: () => setLifeAreasOpen(!lifeAreasOpen),
    };
  }

  return undefined;
};
